document.addEventListener('DOMContentLoaded', function () {
  // === CONFIG ===
  const API_URL = "https://42vnn6vwt9.execute-api.eu-central-1.amazonaws.com/prod2/fabrichanai";

  // Thinking lines while waiting
  const THINKING_LINES = [
    "Analyzing measurements…",
    "Checking fit across the bolt width…",
    "Accounting for seam allowance…",
    "Estimating wastage and practical margins…",
    "Optimizing a cut layout…",
    "Rounding to an orderable length…",
    "Finalizing your tailored estimate…"
  ];

  // === ELEMENTS ===
  const root = document.getElementById('fabrichanai');
  if (!root) return;

  const input = document.getElementById('fabrichanai-input');
  const btn   = document.getElementById('fabrichanai-send');
  const out   = document.getElementById('fabrichanai-results');

  const progressBox = document.getElementById('fc-progress');
  const bar    = document.getElementById('fc-bar');
  const msg    = document.getElementById('fc-msg');
  const submsg = document.getElementById('fc-submsg');

  function selectedUnits(){
    const r = root.querySelector('input[name="fc-units"]:checked');
    return r ? r.value : "cm";
  }

  // --- numeric + escaping helpers ---
  function num(id, def){
    const el = document.getElementById(id);
    if (!el) return def;
    const raw = String(el.value || "").replace(",", ".");
    const v = parseFloat(raw);
    return Number.isFinite(v) ? v : def;
  }
  function esc(s){
    return String(s).replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));
  }
  function fmt(x, digits=2){
    if (x==null || Number.isNaN(x)) return "-";
    return typeof x === "number" ? x.toFixed(digits) : esc(x);
  }

  // --- English-only normalizers (strip or translate Turkish tokens) ---
  const TR_CH = /[çğıöşüÇĞİÖŞÜ]/;
  const TR2EN = {
    "döşemelik kumaş":"upholstery fabric",
    "döşemelik":"upholstery",
    "koltuk kumaşı":"sofa fabric",
    "kanepe kumaşı":"sofa fabric",
    "kanape kumaşı":"sofa fabric",
    "kanepe":"sofa",
    "kanape":"sofa",
    "koltuk":"sofa",
    "yastık":"pillow",
    "yastık kılıfı":"pillow cover",
    "kırlent":"pillow",
    "perdelik":"drapery",
    "ev tekstili":"home textile",
    "keten":"linen",
    "pamuk":"cotton",
    "keten pamuk karışımı":"linen-cotton blend",
    "mikrofiber":"microfiber",
    "çizgili":"striped",
    "desenli":"patterned",
    "leke tutmaz":"stain-resistant",
    "dayanıklı":"durable",
    "polyester":"polyester",
    "linensaten":"linen satin",
    "linsensaten":"linen satin"
  };
  function ensureEnglishText(t, fallback){
    if (!t) return fallback;
    if (TR_CH.test(t)) return fallback;
    // Mostly ASCII check
    if (/^[\x00-\x7F\s.,;:'"()\-–—%/]+$/.test(t)) return t;
    return fallback;
  }
  function normalizeKeywords(list){
    if (!Array.isArray(list)) return [];
    const out = [];
    for (let kw of list){
      if (!kw) continue;
      kw = String(kw).trim();
      const low = kw.toLowerCase();
      if (TR_CH.test(low)){
        if (TR2EN[low]) out.push(TR2EN[low]);
      } else {
        out.push(kw);
      }
    }
    return Array.from(new Set(out)).slice(0,8);
  }

  // --- English badges + soft paragraph (no heavy math notation) ---
  function englishBadges(calc){
    return [
      `Bolt width ${Math.round(calc.fabric_width_cm)} cm`,
      `Seam allowance ${Number(calc.seam_allowance_cm).toFixed(1)} cm`,
      `Wastage ${Math.round(calc.wastage_percent)}%`,
      `Rounding step ${Number(calc.round_to_m).toFixed(2)} m`,
    ];
  }
  function aboutEstimateParagraph(calc){
    const approx = Number(calc.sum_length_m_after_waste || 0);
    const rounded= Number(calc.rounded_order_length_m || 0);
    const step   = Number(calc.round_to_m || 0.5);
    const fw     = Number(calc.fabric_width_cm || 140);
    const seam   = Number(calc.seam_allowance_cm || 1.5);
    const waste  = Math.round(Number(calc.wastage_percent || 12));
    // Keep it gentle and approximate
    return `This is a quick yardage guide based on a ${fw.toFixed(0)} cm bolt width, `
         + `a per-edge seam allowance of ${seam.toFixed(1)} cm and around ${waste}% practical wastage. `
         + `Pieces are placed across the bolt and the total is rounded to the nearest ${step} m step. `
         + `Expect roughly ${approx.toFixed(2)} m in total; for ordering we round to about ${rounded.toFixed(2)} m. `
         + `Treat this as guidance rather than a precise cutting plan.`;
  }

  // --- progress controller ---
  let timer = null, p = 0, iMsg = 0;
  function startProgress(){
    progressBox.hidden = false;
    p = 3; iMsg = 0;
    bar.style.width = p + "%";
    msg.textContent = THINKING_LINES[iMsg % THINKING_LINES.length];
    submsg.textContent = "";
    timer = setInterval(()=>{
      p = Math.min(90, p + Math.random()*4 + 1);
      bar.style.width = p.toFixed(0) + "%";
      if (Math.random() < 0.25){
        iMsg++;
        msg.textContent = THINKING_LINES[iMsg % THINKING_LINES.length];
      }
    }, 700);
  }
  function endProgress(success){
    if (timer) clearInterval(timer);
    bar.style.width = "100%";
    msg.textContent = success ? "Done." : "Something went wrong.";
    submsg.textContent = "";
  }

  // --- main ---
  if (btn && input && out){
    btn.addEventListener('click', async ()=>{
      const prompt = (input.value || "").trim();
      if (!prompt) return;

      out.innerHTML = "";
      btn.disabled = true; input.disabled = true; btn.textContent = "Calculating…";
      startProgress();

      const payload = {
        prompt,
        lang: "en",             // ask backend for English
        fast: true,             // backend fast path
        units: selectedUnits(),
        fabric_width_cm: num('fc-width', 140),
        wastage_percent: num('fc-waste', 12),
        seam_allow_cm:   num('fc-seam', 1.5),
        round_to_m:      num('fc-round', 0.5)
      };

      try{
        const res = await fetch(API_URL, {
          method: 'POST',
          headers: {'Content-Type':'application/json'},
          body: JSON.stringify(payload)
        });
        if (!res.ok){
          let info = "";
          try { const j = await res.json(); info = j && j.error ? ` (${j.error})` : ""; } catch(_){}
          throw new Error(`API responded ${res.status}${info}`);
        }
        const data = await res.json();
        endProgress(true);
        renderResults(data);
      }catch(err){
        endProgress(false);
        out.innerHTML = `
          <div class="fabrichanai-card error">
            <strong>Error:</strong> ${esc(err.message || err)}
          </div>`;
      }finally{
        btn.disabled = false; input.disabled = false; btn.textContent = "Calculate";
      }
    });
  }

  // === UI RENDER ===
  function chip(text){ return `<span class="chip">${esc(text)}</span>`; }

  function renderResults(data){
    const calc = data && data.calculation ? data.calculation : data;
    if (!calc || typeof calc !== 'object'){
      out.innerHTML = `<div class="fabrichanai-card">Unexpected response.</div>`;
      return;
    }

    // HERO (English only)
    const heroValue = (data.display && data.display.hero && data.display.hero.value) ?? calc.rounded_order_length_m;
    const heroHtml = `
      <div class="fabrichanai-hero">
        <div class="hero-number">${fmt(Number(heroValue), 2)} <span class="hero-unit">m</span></div>
        <div class="hero-label">Recommended order length</div>
        <div class="hero-badges">${englishBadges(calc).map(chip).join(" ")}</div>
      </div>
    `;

    // ABOUT (single paragraph, no formulas)
    const aboutHtml = `
      <div class="fabrichanai-card">
        <h3 class="section-title">About this estimate</h3>
        <p class="section-lead">${esc(aboutEstimateParagraph(calc))}</p>
      </div>
    `;

    // STYLE TIP (force English text + translated chips)
    const fallbackTip =
      "Durable linen blends or microfiber are practical for daily use; pair neutrals with a contrasting set of pillows. Vacuum weekly and blot stains with mild soapy water. Order a swatch before committing.";
    const aestheticText = ensureEnglishText((data.aestheticAnalysis || "").trim(), fallbackTip);
    const kws = normalizeKeywords(data.shopping_keywords);
    const aesthetics = `
      <div class="fabrichanai-card">
        <h3 class="section-title">Style tip</h3>
        <p class="section-lead">${esc(aestheticText)}</p>
        ${kws.length ? `<div class="hero-badges">${kws.map(chip).join(" ")}</div>` : ""}
      </div>
    `;

    // TABLE (right-aligned numbers)
    const rows = (calc.lines || []).map((r, idx)=>`
      <tr>
        <td data-label="#" class="num">${idx+1}</td>
        <td data-label="Description">${esc(r.desc || "-")}</td>
        <td data-label="Effective size">${fmt(r.effective_w_cm,1)} × ${fmt(r.effective_l_cm,1)} cm</td>
        <td data-label="Strips" class="num">${fmt(r.strips_across_width,0)}</td>
        <td data-label="Qty" class="num">${fmt(r.count,0)}</td>
        <td data-label="Subtotal length" class="num">${fmt(r.subtotal_length_cm,1)} cm</td>
      </tr>
    `).join("") || `<tr><td colspan="6" class="muted">No line items.</td></tr>`;

    const table = `
      <div class="fabrichanai-card">
        <h3 class="section-title">Line items</h3>
        <table class="fabric-table">
          <thead>
            <tr>
              <th>#</th><th>Description</th><th>Effective size</th>
              <th>Strips</th><th>Qty</th><th>Subtotal length</th>
            </tr>
          </thead>
          <tbody>${rows}</tbody>
        </table>
        <p class="totals">
          <strong>Total after wastage:</strong> ${fmt(calc.sum_length_m_after_waste,2)} m
          (rounded order: <strong>${fmt(calc.rounded_order_length_m,2)} m</strong>)
        </p>
      </div>
    `;

    out.innerHTML = heroHtml + aboutHtml + aesthetics + table;
  }
});
